import { GetRequestsType, RequestsType } from "./types";

export const getRequestSlr = (state: any): GetRequestsType => state.requests.requestsState;

export const requestsSlr = (state: any): RequestsType[] => state.requests.requestsState.data;
